/**
 * NoteSplitMergeTab.jsx — Muhasebe FAZ 4.8, "Senet Parçala/Birleştir" iç sekmesi.
 *
 * İki farklı uç, iki farklı seçim semantiği (parçala: TEK aktif senet;
 * birleştir: aynı faturaya ait EN AZ 2 aktif senet) — bu yüzden tek formda
 * birleştirilmiyor, radiogroup ile modlanıyor. Panellerin kendisi
 * NoteSplitPanel / NoteMergePanel dosyalarında.
 */
import { useState } from 'react';
import { Merge, Scissors } from 'lucide-react';
import { useLanguage } from '../../../contexts/LanguageContext';
import NoteSplitPanel from './NoteSplitPanel';
import NoteMergePanel from './NoteMergePanel';

const MODES = [
  { id: 'split', key: 'accounting.notes.split.mode', icon: Scissors },
  { id: 'merge', key: 'accounting.notes.merge.mode', icon: Merge },
];

export default function NoteSplitMergeTab({ userId, notes }) {
  const { t } = useLanguage();
  const [mode, setMode] = useState('split');

  return (
    <div className="space-y-4">
      <div
        role="radiogroup"
        aria-label={t('accounting.notes_tabs.split_merge')}
        className="inline-flex gap-1 p-1 rounded-xl border-2 border-[var(--border-light)] bg-[var(--bg-app)]"
      >
        {MODES.map((m) => {
          const Icon = m.icon;
          const active = mode === m.id;
          return (
            <button
              key={m.id}
              type="button"
              role="radio"
              aria-checked={active}
              onClick={() => setMode(m.id)}
              data-testid={`note-mode-${m.id}`}
              className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-bold transition-colors ${
                active ? 'bg-white text-[var(--brand-primary)] shadow-sm' : 'text-[var(--text-muted)]'
              }`}
            >
              <Icon size={14} aria-hidden />
              {t(m.key)}
            </button>
          );
        })}
      </div>

      {mode === 'split' ? (
        <NoteSplitPanel userId={userId} notes={notes} />
      ) : (
        <NoteMergePanel userId={userId} notes={notes} />
      )}
    </div>
  );
}
